import { trpc } from "@api/client";

const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export const useIsSetupTierEnabled = (registrationNumber: string) => {
  const { data, error, isLoading } = trpc.isSetupTierEnabled.useQuery(
    { registrationNumber },
    {
      enabled: !!registrationNumber,
      cacheTime: ONE_WEEK_MS,
      staleTime: ONE_WEEK_MS,
    }
  );
  return { isSetupTierEnabled: data, error, isLoading };
};
